<template>
  <main>
    <wl-banner bgUrl='/static/img/product/kfyy/banner.png' :bannerData='bannerData' paddingTop='214px'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1 bg" v-lazy:background-image="'/static/img/product/kfyy/bg1.png'">
      <article class="container flex">
        <wl-title :title='page1Data.title' :desc='page1Data.desc'></wl-title>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/product/bg-cptx-677.png'">
      <article class="container">
        <wl-title title='产品特性' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="box" v-for="(item,index) in page2Data" :key="item.key" @mouseenter="mouseEnter(index)" @mouseleave="page2HoverId = null">
            <section class="_icon " :style="page2HoverId===index?`background-position: -${72+144*index}px 0px;`:`background-position: -${144*index}px 0px;`"></section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/kfyy/bg3.png'">
      <article class="container">
        <wl-title title='应用价值帮您实现' :isNeedDesc=false></wl-title>
        <section class="box" v-for="(item,index) in page3Data" :key="index">
          <h3>{{item.title}}</h3>
          <p>{{item.desc}}</p>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'kfyyManageSystem',
  data() {
    return {
      bannerData: {
        title: '实验室开放预约管理系统  ',
        desc: '管理模式信息化   业务处理模式化\n开放管控过程化   管理数据系统化'
      },
      page1Data: {
        title: '实验室开放预约管理系统',
        desc: '实验室预约管理系统利用物联网智能硬件和业务信息系统联动，使实验室24小时开放成为可能，让实验室开放预约更加规范化、智能化，让实验室开放管理工作能便捷、高效完成，提升实验室开放预约的管理和服务水平。'
      },
      page2Data: [
        { key: 'kfyy-icon1', title: '多样预约，满足多样管理', desc: '灵活设置预约时间段、开放时间，自定义审批流程，灵活配置' },
        { key: 'kfyy-icon2', title: '多模式预约，合规便捷', desc: '整间预约和工位预约，自动排除预约冲突' },
        { key: 'kfyy-icon3', title: '门禁联动，预约授权', desc: '支持与门禁智能联动授权管理，在规定时间打开门禁' },
        { key: 'kfyy-icon4', title: '预约记录，实时查看', desc: '多维度数据统计，高效管理自动生成预约记录、门禁出入记录样本库管理系统' },
      ],
      page2HoverId: null,
      page3Data: [
        { title: '提高实验室开放共享率', desc: '减少资源闲置浪费情况' },
        { title: '加强实验室使用过程管理', desc: '提升实验室开放管理效率' },
      ],
    }
  },
  methods: {
    mouseEnter(index) {
      this.page2HoverId = index
    },
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/product/kfyy/icon.png");
  display: inline-block;
}
main {
  background: #fbfbff;
}
h3 {
  font-size: 22px;
  font-weight: 500;
  color: #262626;
  line-height: 22px;
  padding-bottom: 12px;
  padding-top: 16px;
}
p {
  color: #8e8e8e;
  font-size: 20px;
  line-height: 20px;
  white-space: pre-line;
}
.pt-30 {
  padding-top: 32px !important;
}
.page1 {
  height: 944px;
  padding-top: 136px;
  .container {
    width: 985px;
  }
  ::v-deep strong {
    color: #8e8e8e;
    padding-top: 47px;
    width: 985px;
    line-height: 34px;
  }
}
.page2 {
  height: 677px;
  padding-top: 136px;
  .flexWrap {
    padding-top: 56px;
  }
  .box {
    width: 300px;
    height: 300px;
    background: #ffffff;
    border-radius: 14px;
    padding: 0 20px;
    padding-top: 47px;
    ._icon {
      width: 72px;
      height: 72px;
    }
    p {
      line-height: 30px;
      text-align: left;
    }
    &:hover {
      background: linear-gradient(
        180deg,
        #cbe4ff 0%,
        rgba(59, 157, 255, 0.75) 100%
      );
      h3 {
        color: #fff;
      }
      p {
        color: #fff;
      }
    }
  }
}
.page3 {
  height: 677px;
  padding-top: 223px;
  text-align: left;
  h3 {
    padding: 0;
    padding-bottom: 16px;
    font-size: 24px;
    line-height: 24px;
  }
  .container {
    .box {
      padding-left: 52px;
      padding-bottom: 52px;
      &:nth-child(2) {
        padding-top: 72px;
      }
    }
  }
}
</style>
